module.exports = __webpack_public_path__ + "img/icon-open-popup.741282d7.svg";